import { FormHTMLAttributes, PropsWithChildren } from 'react';

import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  loading: boolean;
}

const FormWrapper = ({
  onSubmit,
  loading,
  children,
  className,
  ...rest
}: PropsWithChildren<FormProps>) => {
  return (
    <form onSubmit={onSubmit} {...rest} className="font-semibold">
      <fieldset aria-busy={loading} className={className} disabled={loading}>
        {children}
      </fieldset>
    </form>
  );
};

const FormGroupHorizontal = ({
  children,
  className,
}: PropsWithClassName<PropsWithChildren>) => {
  return (
    <fieldset className={cn('flex flex-col lg:flex-row gap-4', className)}>
      {children}
    </fieldset>
  );
};

const FormField = ({
  children,
  className,
}: PropsWithClassName<PropsWithChildren>) => {
  return <div className={cn('flex-1', className)}>{children}</div>;
};

const Form = {
  Form: FormWrapper,
  HorizontalGroup: FormGroupHorizontal,
  Field: FormField,
};

export default Form;
